// extracted by mini-css-extract-plugin
module.exports = {"alert":"loJeg_Zf","option":"fg_Eae7R"};